const blogPost = {
  displayField: 'title',
  name: 'z-Blog Post',
  description: 'This is a demo type only used to test out creating a Contentful App.',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'body',
      name: 'Body',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'blogPost',
    version: 12,
    updatedAt: '2023-08-03T14:46:01.048Z'
  }
};
export default blogPost;